// extracted by mini-css-extract-plugin
export default {"container":"not-allowed-screen_container__kzXFD","card":"not-allowed-screen_card__Fl0FR","text":"not-allowed-screen_text__kRkra"};